function updateProductCardLayouts() {
    // Remove previous indicators
    let lastVisibleValues = document.querySelectorAll('.we-option-value--pill-last');
    lastVisibleValues.forEach(value => {
        value.remove();
    });
    
    document.querySelectorAll('.we-option-values').forEach(element => {
        const pills = element.querySelectorAll('.we-option-value--pill');
        const card = element.closest('.card-wrapper');
        const cardWidth = card.offsetWidth;
        
        // First pass: measure all pills and calculate total width
        const pillData = [];
        let totalWidth = 0;
        
        pills.forEach((pill, index) => {
            pill.style.display = 'block';
            const pillWidth = pill.offsetWidth;
            const gapWidth = index < pills.length - 1 ? 4 : 0;
            
            pillData.push({
                pill: pill,
                width: pillWidth,
                gapWidth: gapWidth
            });
            
            totalWidth += pillWidth + gapWidth;
        });
        
        // If no overflow, we're done
        if (totalWidth <= cardWidth) {
            return;
        }
        
        // Second pass: determine which pills to show
        let currentWidth = 0;
        let visiblePills = [];
        
        for (let i = 0; i < pillData.length; i++) {
            const pillWidth = pillData[i].width;
            const gapWidth = pillData[i].gapWidth;
            
            // Check if adding this pill would exceed card width
            if (currentWidth + pillWidth + gapWidth <= cardWidth) {
                currentWidth += pillWidth + gapWidth;
                visiblePills.push(pillData[i]);
            } else {
                pillData[i].pill.style.display = 'none';
            }
        }
        
        // Add indicator if we hid any pills
        if (visiblePills.length < pillData.length) {
            const hiddenCount = pillData.length - visiblePills.length;
            const indicator = document.createElement('span');
            indicator.classList.add('we-option-value--pill', 'we-option-value--pill-last');
            indicator.textContent = '+' + hiddenCount;
            element.appendChild(indicator);
            
            // Check if indicator itself causes overflow
            const indicatorWidth = indicator.offsetWidth;
            if (currentWidth + indicatorWidth > cardWidth && visiblePills.length > 1) {
                // Hide last visible pill to make room for indicator, but only if we have more than 1 visible pill
                const lastVisible = visiblePills[visiblePills.length - 1];
                lastVisible.pill.style.display = 'none';
                visiblePills.pop();
                
                // Update indicator count
                indicator.textContent = '+' + (hiddenCount + 1);
            }
        }
    });
}

// Run on page load
updateProductCardLayouts();

// Run on window resize
window.addEventListener('resize', updateProductCardLayouts);